import { render, staticRenderFns } from "./external_content.vue.js?vue&type=template&id=757f5492!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./external_content.vue?vue&type=template&id=757f5492"
import script from "./external_content.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./external_content.vue?vue&type=script&lang=js"
export * from "./external_content.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./external_content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('757f5492')) {
      api.createRecord('757f5492', component.options)
    } else {
      api.reload('757f5492', component.options)
    }
    module.hot.accept("./external_content.vue.js?vue&type=template&id=757f5492!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./external_content.vue?vue&type=template&id=757f5492", function () {
      api.rerender('757f5492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "behaviors/components/external_content.vue"
export default component.exports